<template>
    <div @click="handleClick" style="cursor: pointer">
        <img
            style="
                width: 100%;
                height: 184px;
                margin-bottom: 20px;
                object-fit: contain;
                background: white;
                border-radius: 20px;
            "
            :src="imageSrc"
            :alt="imageAlt"
        />
        <p
            style="
                margin-left: 20px;
                margin-bottom: 4px;
                font-size: 20px;
                font-weight: bold;
            "
        >
            {{ textTitle }}
        </p>
        <p style="margin-left: 20px; font-size: 12px">{{ textDetail }}</p>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        imageSrc: String,
        imageAlt: {
            type: String,
            default: "Image",
        },
        textTitle: String,
        textDetail: String,
        onClick: Function,
    },
    setup() {
        // 클릭 이벤트 핸들러
        const handleClick = () => {};

        return {
            handleClick,
        };
    },
});
</script>

<style scoped>
img {
    width: 100%; /* 이미지 너비를 컴포넌트에 맞춤 */
}
</style>
